import { ApiResponse } from "../types/common";

import { ApiClient } from "./apiClient";

export interface UploadPictureResponse {
  url: string;
  message: string;
}

const profilePictureService = new ApiClient<UploadPictureResponse>("/Profile");

export const uploadProfilePicture = (
  file: File,
): Promise<ApiResponse<UploadPictureResponse>> => {
  const formData = new FormData();
  formData.append("file", file);

  return profilePictureService.custom("post", "/upload-picture", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteProfilePicture = (): Promise<ApiResponse<void>> => {
  return profilePictureService.custom("delete", "/picture");
};

export default profilePictureService;
